
import { callout } from '../../../style/article';

export default function KitaCallout() {
  return (
    <div css={callout}>
      <h3 id="kita-callout">✅ Carbon credit insured</h3>{' '}
      <p>
        Wren partners with Kita, a Lloyd’s Coverholder, to protect subscribers'
        carbon credit pre-purchases and ensure the promised impact of this
        project.
      </p>
      <p>
        <a
          href="https://www.wren.co/blog/wren-partners-with-kita"
          target="_blank"
          rel="noopener noreferrer"
        >
          How Wren insures climate impact →
        </a>
      </p>
    </div>
  );
}
